import React, { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import ConciergeBookingModal from "./ConciergeBookingModal";

/**
 * Concierge no longer has a Dashboard card. Deep link ?concierge=1 still opens booking.
 */
const ConciergeDeepLinkHost = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get("concierge") !== "1") {
      return;
    }
    setOpen(true);
    const next = new URLSearchParams(searchParams);
    next.delete("concierge");
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  const handleClose = useCallback(() => setOpen(false), []);

  return (
    <ConciergeBookingModal
      isOpen={open}
      onClose={handleClose}
      onSuccess={handleClose}
    />
  );
};

export default ConciergeDeepLinkHost;
